import React from 'react';
import { IconButton, InputBase, Paper, Stack } from '@mui/material';
import { Clear as ClearIcon, Search as SearchIcon } from '@mui/icons-material';
function SearchForm({ defaultValue, onSearch }) {
    const [query, setQuery] = React.useState(defaultValue);
    return (React.createElement(Stack, { gap: 1, direction: "row", sx: { my: 1 } },
        React.createElement(Paper, { onSubmit: (event) => {
                event.preventDefault();
                onSearch(query || '');
            }, component: "form", variant: "outlined", sx: { display: 'flex', alignItems: 'center', flex: 1, backgroundColor: 'transparent' } },
            React.createElement(IconButton, { type: "submit", "aria-label": "search", sx: { minWidth: '60px', borderRadius: 0 } },
                React.createElement(SearchIcon, null)),
            React.createElement(InputBase, { "aria-label": "search-input", sx: { px: 1, flex: 1, height: '100%' }, placeholder: "Search...", value: query || '', onChange: (e) => setQuery(e.target.value.trim()) }),
            React.createElement(IconButton, { sx: { minWidth: '60px', borderRadius: 0 }, onClick: () => {
                    setQuery('');
                    onSearch('');
                } },
                React.createElement(ClearIcon, null)))));
}
export default React.memo(SearchForm);
